<template>
  <div class="admin-talk">
    <a-card>
      <div style="margin:0 0 3rem 0">
        杂言
        <a-textarea placeholder="说点什么" v-model="newTalk"></a-textarea>
        <a-button type="primary" style="float:right;margin:5px" @click="save(true)">发布</a-button>
        <a-button style="float:right;margin:5px" @click="save(false)">保存</a-button>
      </div>
      <a-divider></a-divider>
      <a-list
        class="life-list"
        :pagination="pagination"
        itemLayout="vertical"
        :dataSource="data"
        :loading="loading"
      >
        <a-list-item slot="renderItem" slot-scope="item">
          <div v-if="item.edit">
            <div class="edit-content">
              <a-textarea v-model="item.updateContent"></a-textarea>
              <a-button type="primary" size="small" class="action-button" @click="update(item)">保存</a-button>
              <a-button size="small" style="float:right;margin:5px" @click="cancel(item)">取消</a-button>
            </div>
          </div>
          <div v-else v-html="item.content" class="markdown"></div>

          <span key="comment-basic-publish">
            <a-badge v-if="item.status === 1" color="green" text="已发布" />
            <a-badge v-else color="red" text="未发布" />
          </span>

          <span key="comment-to-publish">
            <a-button type="link" @click="publish(item)">{{item.status ===1?"撤销发布":"发布杂言"}}</a-button>
          </span>

          <span key="comment-basic-edit">
            <a-button type="link" @click="edit(item)">编辑</a-button>
          </span>

          <span key="comment-basic-delete">
            <a-dropdown :trigger="['click']" slot="actions">
              <a>更多</a>
              <a-menu slot="overlay">
                <a-menu-item key="delete" @click="deleteTalk(item)">删除</a-menu-item>
              </a-menu>
            </a-dropdown>
          </span>
          <span style="color:#999;margin-left:1rem">{{item.time}}</span>
          <!-- <a-tooltip
            style="color:#999;margin-left:1rem"
            :title="item.time.format('YYYY-MM-DD HH:mm:ss')"
          >
            <span>{{ item.time.fromNow() }}</span>
          </a-tooltip>-->
        </a-list-item>
        <!-- <div slot="header">
          杂言
          <div>
          <a-textarea placeholder="说点什么" v-model="newTalk"></a-textarea>
          <a-button type="primary" style="float:right">新增</a-button>
          </div>
        </div>-->
      </a-list>
    </a-card>
  </div>
</template>

<script>
// import moment from "moment";
import Toc from "../../utils/Toc.js";
import serverPath from "../../serverPath";
const PAGESIZE = 10;
export default {
  name: "aadmin-talk",
  data() {
    return {
      newTalk: "",
      likes: 0,
      action: null,
      // moment,
      data: [],
      total: 0,
      loading: {
        size: "large",
        tip: "解析markedown中……",
        indicator: <a-icon type="loading" style="font-size: 24px" spin />
      }
    };
  },
  computed: {
    pagination() {
      return {
        pageSize: PAGESIZE,
        total: this.total || 0,
        onChange: (currentPage, pageSize) => {
          this.getBlogTalk(currentPage, pageSize);
        }
      };
    }
  },
  methods: {
    save(publish) {
      let data = { content: this.newTalk };
      if (publish) {
        data.status = 1;
      }
      if (this.newTalk != "") {
        this.axios({
          url: serverPath.adminTalk,
          method: "post",
          data: data
        })
          .then(res => {
            // console.log(res.data);

            if (res.status === 200) {
              this.$message.success("保存成功！");
              this.newTalk = "";
              this.getBlogTalk();
            } else {
              this.$message.error(
                "数据获取失败，错误代码：" + res.stratus + "," + res.statusText
              );
            }
          })
          .catch(e => {
            this.$notification["error"]({
              message: "数据获取失败",
              description: e.toString(),
              duration: 0,
              placement: "topLeft",
              style: {
                marginTop: "2rem"
              }
            });
          });
      } else {
        this.$message.error("内容不能为空！");
      }
    },
    update(talk) {
      let newData = [...this.data];
      let target = this.data.filter(item => item.id == talk.id)[0];
      if (target) {
        this.axios({
          url: serverPath.adminTalk + "/" + talk.id,
          method: "put",
          data: { content: target.updateContent }
        })
          .then(res => {
            if (res.data.state === "ok") {
              this.$message.success(res.data.msg);
            } else {
              this.$message.error("更新失败：" + res.data.msg);
            }
          })
          .catch(e => {
            this.$message.error("更新失败：" + e);
          });
        target.content = Toc.mdToHtml(target.updateContent || "");
        target.edit = false;
        this.data = newData;
      }
    },
    cancel(talk) {
      let newData = [...this.data];
      let target = this.data.filter(item => item.id == talk.id)[0];
      if (target) {
        target.edit = false;
        this.data = newData;
      }
    },
    publish(talk) {
      let newData = [...this.data];
      let target = this.data.filter(item => item.id == talk.id)[0];
      if (target) {
        // let _status = talk.status == 1 ? 0 : 1;
        let publishStatus = talk.status === 1 ? 0 : 1;
        this.axios({
          url: serverPath.adminTalk + "/" + talk.id + "/publish",
          method: "post",
          data: { publish: publishStatus }
        })
          .then(res => {
            if (res.status === 200 && res.data.state === "ok") {
              this.$message.success(res.data.msg);
              // this.list.some(item => {
              //   if (item.id === talk.id) {
              //     item.status = publishStatus;
              //     return true;
              //   }
              // });
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch(e => {
            this.$message.error("文章发布更改失败！" + e);
          });
        target.status = publishStatus;
        this.data = newData;
      }
    },
    edit(talk) {
      let newData = [...this.data];
      let target = this.data.filter(item => item.id == talk.id)[0];
      if (target) {
        target.edit = true;
        this.data = newData;
      }
      //   this.data.some(item => {
      //     if (item.id === talk.id) {
      //       item.edit = true;
      //       return true;
      //     }
      //   });
      // console.log(talk);
    },
    deleteTalk(talk) {
      let that = this;
      this.$confirm({
        title: "是否删除?",
        // content: `ID：${talk.id}，标题：${talk.content}`,
        onOk() {
          that
            .axios({
              url: serverPath.adminTalk + "/" + talk.id,
              method: "delete"
            })
            .then(res => {
              if (res.status === 200 && res.data.state === "ok") {
                that.$message.success(res.data.msg);
                that.data = that.data.filter(item => item.id != talk.id);
              } else {
                that.$message.error(res.data.msg);
              }
            })
            .catch(e => {
              that.$message.error("删除失败！" + e);
            });
        },
        onCancel() {}
      });
    },
    getBlogTalk(currentPage = 1, pageSize = PAGESIZE) {
      this.axios({
        url: serverPath.adminTalk,
        methods: "get",
        params: {
          currentPage: currentPage,
          pageSize: pageSize
        }
      })
        .then(res => {
          if (res.status === 200) {
            this.data = res.data.list;
            this.data.map(item => {
              // item.time = moment(item.time);
              item.updateContent = item.content;
              item.content = Toc.mdToHtml(item.content || "");
              item.action = null;
            });
            this.total = res.data.total;
            this.loading = false;
          } else {
            this.$message.error(
              "数据获取失败，错误代码：" + res.stratus + "," + res.statusText
            );
          }
        })
        .catch(e => {
          this.$notification["error"]({
            message: "数据获取失败",
            description: e.toString(),
            duration: 0,
            placement: "topLeft",
            style: {
              marginTop: "2rem"
            }
          });
        });
    }
  },
  mounted() {
    this.getBlogTalk();
  }
};
</script>

<style lang="scss" scoped>
.admin-talk {
  padding: 1rem;
}
.action-button {
  float: right;
  margin: 5px;
}

@media screen and (min-width: 768px) {
  .edit-content {
    width: 80%;
  }
}
@media screen and (max-width: 768px) {
  .edit-content {
    width: 100%;
  }
}
</style>